import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { FindHttpError } from '../error/find-http-error';
import { HttpError } from '../error/http-error';
import { AccessoryAmount } from '../model/accessory-amount';
import { UpdateHttpError } from '../error/update-http-error';
import { Movement } from '../model/movement';
import {SaveHttpError} from "../error/save-http-error";

@Injectable()
export class AccessoryAmountService {
  private static ACCESSORY_AMOUNT_ENDPOINT = '/accessoryAmount';

  find$: Observable<Map<string, Array<AccessoryAmount>>>;
  move$: Observable<any>;
  error$: Observable<HttpError>;
  save$: Observable<AccessoryAmount>;

  private findSubject: Subject<Map<string, Array<AccessoryAmount>>>;
  private saveSubject: Subject<AccessoryAmount>;
  private moveSubject: Subject<any>;
  private errorSubject: Subject<HttpError>;

  private FIND_ACCESSORIES_BY_LOCAL = `${AccessoryAmountService.ACCESSORY_AMOUNT_ENDPOINT}/groupByAccessory`;
  private MOVE = `${AccessoryAmountService.ACCESSORY_AMOUNT_ENDPOINT}/move`;

  constructor(private _httpService: HttpService) {
    this.saveSubject = new Subject();
    this.save$ = this.saveSubject.asObservable();
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.moveSubject = new Subject();
    this.move$ = this.moveSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  save(accessoryAmount: AccessoryAmount) {
    this._httpService.post(AccessoryAmountService.ACCESSORY_AMOUNT_ENDPOINT, accessoryAmount, AccessoryAmount, SaveHttpError)
      .subscribe(
        tech => this.saveSubject.next(tech),
        error => this.errorSubject.next(error)
      );
  }

  move(movement: Movement) {
    this._httpService.put(this.MOVE, movement, Movement, UpdateHttpError)
      .subscribe(
        () => this.moveSubject.next(),
        error => this.errorSubject.next(error)
      );
  }

  findAccessoryAmount(local) {
    this._httpService.get(`${this.FIND_ACCESSORIES_BY_LOCAL}?localId=${local.id}&localType=${local.accessoryLocalType}`,
                          Map, FindHttpError)
      .subscribe(
        accessoryAmount => this.findSubject.next(accessoryAmount),
        error => this.errorSubject.next(error)
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/accessory-amount.service.ts